<section>
  <nav class="navbar navbar-expand-lg navbar-light transparent">
    <div class="col-6 p-0 d-flex align-items-center">
      <a routerLink="/vyas">
        <img src="../../../assets/img/back_button.svg" alt=""
      /></a>
      <a class="mb-0 pl-3 pr-3 d-lg-inline-block title_get">Game</a>
    </div>
  </nav>

  <div class="container">
    <div class="row">
      <div class="col-6">
        <p class="text-bold">meterId : {{ meterId }}</p>
      </div>
    </div>
    <div class="row">
      <!-- <div class="col-6">
        <label>Time left</label><br />
        <span id="countdown" style="font-weight: bold">5 secs</span>
      </div> -->
      <div class="col-6">
        <label>Points</label><br />
        <span id="points" style="font-weight: bold">{{ points }}</span>
      </div>
    </div>
  </div>

  <div class="container mt-5" id="graph_container">
    <div class="row mt-3">
      <div class="col">
        <div class="card">
          <div class="card-body">
            <p class="text-center" style="font-size: 14px">
              Consumption (in Watts)
            </p>
            <canvas id="myChart"></canvas>
          </div>
        </div>
      </div>
    </div>
    <p>{{this.lastActivePower}}</p>
  </div>
 
  <div class="container mt-5">
    <div class="row">
      <div class="col-4">
        <button
          class="btn abort_btn"
          [disabled]="buttonEnable"
          (click)="predicate('gt')"
        >
          UP
        </button>
      </div>
      <div class="col-4">
        <button
          class="btn abort_btn"
          [disabled]="buttonEnable"
          (click)="predicate('eq')"
        >
          Neural
        </button>
      </div>
      <div class="col-4">
        <button
          class="btn abort_btn"
          [disabled]="buttonEnable"
          (click)="predicate('lt')"
        >
          Down
        </button>
      </div>
    </div>
  </div>
</section>
